import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	resolvedLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	resolvedLabel: {
		id: 'resolved-date.read.resolved-label',
		defaultMessage: 'Resolved',
		description: 'Label for resolved field',
	},
});
export default messages;
